import { PaginationParamType } from "type";
import { Store } from "../../mst_store/types/store";

export interface Tire {
  id: number;
  item_cd: string;
  jan_cd: string;
  tire_category?: string | null;
  tire_size: string;
  brand_cd: string;
  recommend_flag: number;
  tire_width: number;
  tire_aspect_ratio: number;
  tire_rim_diam: string;
  tire_loin_speed_mark: string;
  tire_label: string;
  remarks: string;
  status_flag: number;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
  mst_item_brand_detail_tire: MstItemBrandDetailTire;
  mst_yh_item: MstYhItem;
  mst_item_cashback: MstItemCashback;
  mst_proc_fee: MstProcFee;
  mst_4bundle_price_twset: Mst4BundlePriceTwset;
  mst_item_detail: MstItemDetail;
}

export interface MstItemBrandDetailTire {
  id: number;
  brand_cd: string;
  maker_name: string;
  brand_name: string;
  sale_price_rate_atable: number;
  fixed_discount: number;
  store_cd: string;
  status_flag: number;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
}

export interface MstYhItem {
  id: number;
  item_cd: string;
  jan_cd: string;
  brand_cd: string;
  item_category_l: string;
  item_category_m: string;
  item_category_s: string;
  item_name: string;
  shipping_dest_cd: string;
  item_size: string;
  waste_num_flag: number;
  list_price: number;
  a_price: number;
  main_vendor_cd: string;
  main_purchase_cost: number;
  maker_item_cd: string;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
}

export interface MstItemCashback {
  id: number;
  item_cd: string;
  cb_tire_price: number | string;
  cb_wheel_price: number | string;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
}

export interface MstProcFee {
  id: number;
  rim_diam?: string | null;
  replac_labor_cost: number;
  waste_tire_cost: number;
  rubber_stem_valve_cost: number;
  nitrogen_inflation_cost: number;
  hub_rust_prevention_cost: number;
  store_cd: string;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
}

export interface Mst4BundlePriceTwset {
  id: number;
  item_cd: string;
  store_cd: string;
  tire_4_price: number;
  winter_wheel_4_price: number;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
}

export interface TireResponse {
  total: number;
  list: Tire[];
}

export interface MstItemDetailTireSelectRequest {
  item_cd?: string;
  jan_cd?: string;
  tire_size?: string;
  brand_cd?: string;
  tire_speed_mark?: string;
  tire_label?: string;
  recommend_flag?: number;
  limit: number;
  offset: number;
}

export interface MstItemDetail {
  id: number;
  item_cd: string;
  item_name: string;
  ec_flag: number;
  vendor_cd_2nd: string;
  vendor_cd_3rd: string;
  hatchu_unit: number;
  status_flag: number;
  delete_flag: number;
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
}

export interface MstYhItemBrand {
  brand_cd: string;
  brand_name: string;
  created_at: string;
  created_by: string;
  delete_flag: number;
  id: number;
  maker_name: string;
  status_flag: number;
  updated_at: string;
  updated_by: string;
}

export interface TireBrandType {
  brand_cd: string;
  maker_name: string;
  brand_name: string;
  item_category_m: string;
  fixed_discount?: number;
  sale_price_rate_atable?: number;
  set_profit_ratio?: number;
  fixed_discount_store_login_edit_flag: number;
  sale_price_rate_atable_store_login_edit_flag: number;
  set_profit_ratio_store_login_edit_flag: number;
}

export interface BrandDetailTireSelectResponse {
  list: TireBrandType[];
  total: number;
}

export interface CategoryResponse {
  list: any[];
  total: number;
}

export interface PriceSettingMethod {
  list: Store[];
}

export interface BrandDetailTireUpdateRequest {
  brand_cd: string;
  maker_name?: string;
  brand_name?: string;
  item_category_m?: string;
  sale_price_rate_atable?: number;
  fixed_discount?: number;
  set_profit_ratio?: number;
  store_cd?: string;
  column_delete_flag?: number;
}

export type BrandDetailTireEdit = BrandDetailTireUpdateRequest & {
  item_category_m: string;
  fixed_discount_color: "red" | "black";
  sale_price_rate_atable_color: "red" | "black";
  set_profit_ratio_color?: "red" | "black";
};

export interface BrandDetailParams extends PaginationParamType {
  item_category_m?: string;
  maker_or_brand?: string;
}

export interface StorePriceSettingParams {
  store_cd: string;
  mst_store_price_setting_tire: number;
}

export const PRICE_SETTING_TIRE = {
  SELLING: 0,
  COST: 1,
} as const;
